import { render, staticRenderFns } from "./ProductListCustomCheckbox.vue?vue&type=template&id=ed89c8ca&"
import script from "./ProductListCustomCheckbox.vue?vue&type=script&lang=ts&"
export * from "./ProductListCustomCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports